"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusLabel = exports.StatusType = void 0;
var StatusType;
(function (StatusType) {
    StatusType["NONE"] = "none";
    StatusType["INFORMED"] = "informed";
    StatusType["APPLIED"] = "applied";
})(StatusType || (exports.StatusType = StatusType = {}));
// ステータスに対応するラベルを定義
const statusLabels = {
    [StatusType.NONE]: "未応募",
    [StatusType.INFORMED]: "案内済み",
    [StatusType.APPLIED]: "添削待ち",
};
// ステータスのラベルを取得する関数
const getStatusLabel = (status) => {
    return statusLabels[status] || "";
};
exports.getStatusLabel = getStatusLabel;
